module.exports = __webpack_public_path__ + "img/sign_up_corner.932da8bc.svg";